import request from '@wearetla/tla-essentials-tools/utilities/request';
import omit from 'lodash/omit';
import { createI18nInstance } from '/utilities/i18n';

// Functions
import formatDate from '/functions/format-date';

const getT = () => createI18nInstance().t;

export const findMenuCategory = (menu, categoryId) => {
	const menuCategory = menu?.menus.find((category) => category.id.toString() === categoryId?.toString());

	if (menuCategory) {
		return {
			updated_at: menu.updated_at,
			updated_at_formatted: menu.updated_at_formatted,
			...menuCategory,
		};
	}

	return null;
};

const menuServices = {
	getMenu: (branchSlug) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				const merchant = payload?.menu?.merchants?.[0];

				if (merchant) {
					const menus = merchant.menus ?? [];

					resolve({
						title: payload.menu.title,
						updated_at: merchant.updated_at,
						updated_at_formatted: formatDate(merchant.updated_at),
						menus,
						categories: menus.reduce((categories, menu) => {
							if (menu.products?.length) {
								return [
									...categories,
									{
										...omit(menu, ['products']),
										product_count: menu.products.length,
									},
								];
							}

							return categories;
						}, []),
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	getMenuProduct: (productId) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/product/${productId}`, false, (payload, status, request) => {
				if (payload?.merchant_menu_product) {
					resolve({
						...payload.merchant_menu_product,
						category: payload.merchant_menu,
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Ürün getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	getMenuSearchResults: (branchSlug, query) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}/products`, { query }, (payload, status, request) => {
				if (payload?.menu) {
					resolve({
						query,
						results: payload.menu,
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
};

export default menuServices;
